import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '@/src/services/api-service';
import { HOME_MOVES_ENDPOINTS } from './endpoints';
import {
  CancelMoveOutSuccessResponse,
  CancelMoveOutErrorResponse,
} from './types';

type CancelMoveOutInput = {
  accountId: string;
};

export function useCancelMoveOutMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    CancelMoveOutSuccessResponse,
    CancelMoveOutErrorResponse,
    CancelMoveOutInput
  >(
    async ({ accountId }) => {
      const response = await apiService.delete<CancelMoveOutSuccessResponse>({
        url: HOME_MOVES_ENDPOINTS.cancelMoveOut(accountId),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    },
    {
      onSuccess: (_, variables) => {
        // Invalidate related queries
        queryClient.invalidateQueries([
          'home-moves',
          'status',
          variables.accountId,
        ]);
        queryClient.invalidateQueries([
          'home-moves',
          'customer',
          variables.accountId,
        ]);
        // Also invalidate old queries for backward compatibility during migration
        queryClient.invalidateQueries(`moveout-kapi-${variables.accountId}`);
      },
      onError: error => {
        console.error('Error canceling move-out:', error);
      },
    },
  );
}
